const MASK = {
  phone: "(###) ###-####"
};

export { MASK };
